import {
  req,
  Request
} from '../Repository';
import {
  setFullToken,
  checkTokenHeaders
} from '../apiHelper'

const resource = '/sharedfile';

export default {
  getSharedFiles: (idCompany, token) => {
    return req(token).then(token => {
      return Request.get(`${resource}/getsharedfileslistbyuser?companyId=${idCompany}`, token);
    })
  },
  deleteFileById: (idFile, token) => {
    return req(token).then(token => {
      return Request.delete(`${resource}/deletesharedfile?idFile=${idFile}`, token);
    })
  }

}
